import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import EcommercePrompt from '../../../components/EcommercePrompt/EcommercePrompt';
import NotificationPreview from '../../../components/NotificationPreview/NotificationPreview';
import { ERRORS } from '../../../constants/AppConstants';
import { getPriceDropData, updatePriceDropData } from '../../../services/woocommerceService';


const WooPriceDrop = () => {
    
    const { selectedWebsite,
        setIsDirty,
        setPathToNavigate,
        setDiscardPromptOpen,
        isDirty, 
    } = useAppContext();
    
    const history = useHistory();

    const [priceDrop, setPriceDrop] = useState(null);
    
    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);

    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(null);
    const [messageLengthError, setMessageLengthError] = useState(null);

    const [floatingTitle, setFloatingTitle] = useState('');
    const [floatingTitleError, setFloatingTitleError] = useState(null);

    const [floatingMessage, setFloatingMessage] = useState('');
    const [floatingMessageError, setFloatingMessageError] = useState(null);
    const [floatingMessageLengthError, setFloatingMessageLengthError] = useState(null);

    const [floatingButton, setFloatingButton] = useState('');
    const [floatingButtonError, setFloatingButtonError] = useState('');

    const [floatingSuccess, setFloatingSuccess] = useState('');
    const [floatingSuccessError, setFloatingSuccessError] = useState('');

    const [floatingTheme, setFloatingTheme] = useState(null);

    useEffect(() => {

        const discard = () => {
            setPriceDropData(priceDrop);
        }

        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [priceDrop])

    useQuery(
        ['fetchWooPriceDrop', selectedWebsite?.id], 
        () => getPriceDropData(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess: (priceDropData) => {
                if(priceDropData) {
                    setPriceDrop(priceDropData);
                    setPriceDropData(priceDropData);
                } else {
                    toast.error('Something went wrong!!');
                }
            }
        }
    )

    const handelTitleChange = (value) => {
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setTitleError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 100 ) {
            setTitle(value);
        }
    }

    const handelMessageChange = (value) => {
        if(value.trim().length > 120 ) {
            setMessageLengthError(ERRORS.WEBSITE_MESSAGE_MAX_LENGTH);
        }
        else {
            setMessageLengthError(null)
            setMessageError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 300 ) {
            setMessage(value);
        }
    }

    const handelFloatingTitleChange = (value) => {
        if(value.trim().length <=0 ) {
            setFloatingTitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setFloatingTitleError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 25 ) {
            setFloatingTitle(value);
        }
    }

    const handelFloatingMessageChange = (value) => {
        if(value.trim().length < 0 ) {
            setFloatingButtonError(ERRORS.MESSAGE_REQUIRED);
        }
        else {
            setFloatingMessageLengthError(null)
            setFloatingMessageError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 150 ) {
            setFloatingMessage(value);
        }
    }

    const handelFloatingButtonChange = (value) => {
        if(value.trim().length <=0 ) {
            setFloatingButtonError(ERRORS.BUTTON_TEXT_REQUIRED);
        }
        else {
            setFloatingButtonError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 15 ) {
            setFloatingButton(value);
        }
    }

    const handelFloatingSuccessChange = (value) => {
        if(value.trim().length <=0 ) {
            setFloatingSuccessError(ERRORS.ECOM_SUCCESSS_REQUIRED);
        }
        else {
            setFloatingSuccessError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 100 ) {
            setFloatingSuccess(value);
        }
    }

    const handelFloatingThemeChange = (value) => {
        setIsDirty(true);
        setFloatingTheme(value);
       
    }

    const onBack = () => {
        if(isDirty) {
        setPathToNavigate('/woocommerce-automation');
        setDiscardPromptOpen(true);
        } else {
            history.push('/woocommerce-automation');
        }
    }


    const setPriceDropData = (prizeDropData) => {
        setTitle(prizeDropData?.notif_title);
        setMessage(prizeDropData?.notif_message);
        setFloatingTitle(prizeDropData?.popup_title);
        setFloatingMessage(prizeDropData?.popup_message);
        setFloatingTheme(prizeDropData?.popup_color);
        setFloatingButton(prizeDropData?.popup_button_text);
        setFloatingSuccess(prizeDropData?.popup_success_message);
    }

    const updatePriceDrop = useMutation((event) => {
        event.preventDefault();
        const priceDropData = {
            notif_title: title,
            notif_message: message,
            popup_title: floatingTitle,
            popup_message: floatingMessage,
            popup_color: floatingTheme,
            popup_button_text: floatingButton,
            popup_success_message: floatingSuccess,
        };
        return updatePriceDropData(selectedWebsite?.id, priceDropData)},
        {
            onSuccess: (backInStockData) => {
                setPriceDrop(backInStockData);
                setPriceDropData(backInStockData);
                setIsDirty(false);
                toast.success('Price Drop Notification details updated successfully');
            }
        }
    );

    const isSaveDisabled = () => {
        return title.length <= 0  || titleError || messageError || floatingTitle.length <=0 || floatingTitleError || floatingMessage.length <= 0 
        || floatingMessageError || floatingButton.length < 0 || floatingButtonError || floatingSuccess.length < 0 || floatingSuccessError;
    }

    const discard = () => {
        setDiscardPromptOpen(true);
    }

    


    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div>
                    <h3 className="mb-0">
                        <i className="icon icon-chevron-left mr-2" onClick={onBack} ></i> 
                        Price Drop Notification Settings</h3>
                    </div>
                    <div className="d-flex justify-content-between">
                        <button className="btn btn-sm btn-danger mr-2" onClick={discard} >Discard</button>
                        <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={updatePriceDrop.mutate} >Save</button>                                         
                    </div> 
                </div>                                   
            </div>
            <div className="panel-body full-height scrollable_y">
            <div className="row">
                <div className="col">
                    <h5 className="medium mb-3">Notification Settings</h5>
                    {/* <div className="form-group d-flex flex-column">
                        <label className="thin text-light">Active</label>
                        <label className="toggle-control toggle-control-xs mb-2">
                            <input type="checkbox" checked="checked" />
                            <span className="control"></span>
                        </label>                                            
                    </div> */}
                    <span>Allow Your Customers to subscribe for push notifications when products come back in stock.</span>
                    <div className="form-group">
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Notification Title *</label>
                            <div>{title.length} / 100</div>
                        </div>
                        <div className="input-addon input-group-right">
                            <i className="icon icon-edit"></i>
                            <input
                                type="text"
                                placeholder="Product [product-name] is back in stock!"
                                className="form-control"
                                value={title}
                                onChange={({target}) => handelTitleChange(target.value)}
                                maxLength={100}    
                            />                        
                        </div>
                        <span>Note:You can use the [product-name] keyword as placeholder that will be dynamically replaced with the real value.</span>
                        { titleError && <div><span className="error-message">{titleError}</span></div>}
                    </div>
                    <div className="form-group">
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Notification Message</label>
                            <div>{message.length} / 300</div>
                        </div>
                        <div className="input-addon input-group-right">
                            <i className="icon icon-edit"></i>
                            <textarea
                                type="text"
                                placeholder="A product [product-name] that you follow is back in stock."
                                className="form-control"
                                value={message}
                                onChange={({target}) => handelMessageChange(target.value)}    
                                maxLength={300}
                            ></textarea>                        
                        </div>
                        <span>Note: You can use the [product-name] keyword as placeholder that will be dynamically replaced with the real value.</span>
                        { messageError && <div><span className="error-message">{messageError}</span></div>}
                        { messageLengthError && <div><span className="error-message">{messageLengthError}</span></div>}
                    </div>
                </div>
                <NotificationPreview
                    title={title}
                    message={message}
                    icon={selectedWebsite?.logo}
                    is_cta_enabled = {false}
                    isCTA2Enabled = {false}
                    button={''}
                    addl_button={''}
                />
            </div>
            <hr className="my-4"/>
            <div className="row">
                <div className="col">
                    <h5 className="medium mb-3">Permission Prompt Settings</h5>
                    <div className="form-group">                   
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Title *</label>
                            <div>{floatingTitle.length} / 25    </div>
                        </div>
                        <input 
                            type="text" 
                            placeholder="Price drop alert?" 
                            value={floatingTitle} 
                            className="form-control"
                            onChange={({target}) => handelFloatingTitleChange(target.value)}
                            maxLength={25}    
                        />  
                        { floatingTitleError && <div><span className="error-message">{floatingTitleError}</span></div>}                
                    </div>
                    <div className="form-group">                   
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Message *</label>
                            <div>{floatingMessage.length} / 150    </div>
                        </div>
                        <textarea 
                            type="text" 
                            placeholder="Notify me once this item is back in stock. Flating Lable Message" 
                            value={floatingMessage} 
                            className="form-control"
                            onChange={({target}) =>handelFloatingMessageChange(target.value)}
                            maxLength={150}    
                        ></textarea>  
                        { floatingMessageError && <div><span className="error-message">{floatingMessageError}</span></div>}
                        { floatingMessageLengthError && <div><span className="error-message">{floatingMessageLengthError}</span></div>}            
                    </div>
                    <div className="form-group">                   
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Button *</label>
                            <div>{floatingButton.length} / 15    </div>
                        </div>
                        <input type="text" 
                            placeholder="Notify Me" 
                            value={floatingButton}
                            className="form-control"
                            onChange={({target}) => handelFloatingButtonChange(target.value)}
                            maxLength={15}     
                        /> 
                        { floatingButtonError && <div><span className="error-message">{floatingButtonError}</span></div>} 
                    </div>
                    <div className="form-group">                   
                        <label className="form-label text-dark medium">Success*</label>
                        <input 
                            type="text" 
                            value={floatingSuccess}
                            placeholder="When [product-name] becomes available, you'll be the first to know." 
                            className="form-control"
                            onChange={({target}) => handelFloatingSuccessChange(target.value)}
                            maxLength={100}
                            />  
                    </div>
                    <div className="form-row">                   
                        <label className="col-1 form-label text-dark medium">Color </label>
                        <div className="col-2">
                            <input 
                                type="color" 
                                className="form-control"
                                value={floatingTheme}
                                onChange={({target}) => handelFloatingThemeChange(target.value)}     
                            />
                        </div>
                        
                    </div>
                </div>
                <div className="col price-drop-column">
                    <EcommercePrompt 
                        title={floatingTitle}
                        message={floatingMessage}
                        theme={floatingTheme}
                        button={floatingButton}
                    />
                </div>
            </div>
        </div>
        </div>
    </>
}

export default WooPriceDrop;